import { getI18nJsonProp } from "@/shared/i18n/locales/getI18nJsonProp";
import base from "./base.json";
import vehicleApplications from "./vehicle-applications.json";
import vehicleRegistration from "./vehicle-registration.json";

const thgQuote = {
  ...getI18nJsonProp(base, "thgQuote"),
  ...getI18nJsonProp(vehicleApplications, "thgQuote"),
  ...getI18nJsonProp(vehicleRegistration, "thgQuote"),
};

export default thgQuote;
